'use client';

import { createContext, JSX, useState } from 'react';
import React from 'react';
export type Breadcrumbs = { id: string[]; path: string[] };

export type ContextProps = {
  isVerificationModalOpen: boolean;
  setIsVerificationModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
export const ModalsContext = createContext({} as ContextProps);

export const ModalsProvider = ({ children }: { children: JSX.Element }) => {
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false);

  return (
    <ModalsContext.Provider
      value={{
        isVerificationModalOpen,
        setIsVerificationModalOpen,
      }}
    >
      {children}
    </ModalsContext.Provider>
  );
};
